module.exports = __webpack_public_path__ + "img/main_raon.eff7c6e6.jpg";